(function (global) {
  'use strict';

  var productCache = Object.create(null);

  function routesRoot() {
    return global.Shopify && global.Shopify.routes && global.Shopify.routes.root
      ? global.Shopify.routes.root
      : '/';
  }

  function getOptionIndices(product) {
    var firstVariant = product.variants && product.variants[0];
    if (!firstVariant) {
      return { sizeIdx: 0, flavorIdx: 1 };
    }
    if (isNaN(parseInt(firstVariant.option1, 10))) {
      return { sizeIdx: 1, flavorIdx: 0 };
    }
    return { sizeIdx: 0, flavorIdx: 1 };
  }

  function variantIdFromLineItem($lineItem) {
    if (!$lineItem || !$lineItem.length) return null;
    var fromAttr = parseInt($lineItem.attr('data-variant-id'), 10);
    if (Number.isFinite(fromAttr)) return fromAttr;
    var idAttr = String($lineItem.find('.cart-items__item-quantity').attr('id') || '');
    var m = idAttr.match(/^cart-item-quantity-(\d+)$/);
    return m ? parseInt(m[1], 10) : null;
  }

  function lineItemEligibleForTier($lineItem) {
    if (!$lineItem || !$lineItem.length) return false;
    if ($lineItem.hasClass('cart-items__line-item--bundle')) return false;
    if ($lineItem.hasClass('cart-items__line-item--bundle_gift')) return false;
    if ($lineItem.attr('data-bundle-id')) return false;
    if ($lineItem.attr('data-tier-qty-disabled') === 'true') return false;
    var handle = $lineItem.attr('data-product-handle');
    return !!handle;
  }

  function productUsesTierPricing(product) {
    var tags = product.tags || [];
    if (tags.indexOf('gear') !== -1) return false;
    if (tags.indexOf('_rebranding') !== -1) return true;
    return (product.variants || []).some(function (v) {
      return v.options && v.options.length > 1;
    });
  }

  function resolveTierVariantForQuantity(product, currentVariantId, quantity) {
    var variants = product.variants || [];
    var current = variants.find(function (v) {
      return v.id === parseInt(currentVariantId, 10);
    });
    if (!current) return null;

    var tags = product.tags || [];
    var isRebrandingProduct = tags.indexOf('_rebranding') !== -1;
    var isGearProduct = tags.indexOf('gear') !== -1;
    var indices = getOptionIndices(product);
    var sizeIdx = indices.sizeIdx;
    var flavorIdx = indices.flavorIdx;
    var filteredVariant = current;

    if (isRebrandingProduct) {
      filteredVariant = variants
        .filter(function (variant) {
          return (
            parseInt(variant.options[sizeIdx], 10) <= quantity && variant.title.indexOf('OFF') === -1
          );
        })
        .pop();
    } else if (variants.some(function (v) { return v.options && v.options.length > 1; }) && !isGearProduct) {
      filteredVariant = variants
        .filter(function (varia) {
          return (
            parseInt(varia.options[sizeIdx], 10) <= quantity &&
            varia.options[flavorIdx] === current.options[flavorIdx]
          );
        })
        .pop();
    } else {
      return null;
    }

    return filteredVariant || null;
  }

  function fetchProductByHandle(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    var url = routesRoot() + 'products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load product: ' + handle);
        return res.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      });
  }

  function postCartJson(endpoint, body) {
    return fetch(routesRoot() + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) {
          throw new Error(t || res.statusText);
        });
      }
      return res.json();
    });
  }

  function fetchCart() {
    return fetch(routesRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('cart.js failed');
      return res.json();
    });
  }

  /**
  
   * @returns {Promise<object|null>}
   */
  function trySwapLineForQuantity($lineItem, quantity, changeTarget) {
    var qty = parseInt(quantity, 10);
    if (!Number.isFinite(qty) || qty < 1) {
      return Promise.resolve(null);
    }
    if (!lineItemEligibleForTier($lineItem)) {
      return Promise.resolve(null);
    }

    var handle = $lineItem.attr('data-product-handle');
    var currentVariantId = variantIdFromLineItem($lineItem);
    if (!handle || currentVariantId == null) {
      return Promise.resolve(null);
    }

    return fetchProductByHandle(handle)
      .then(function (product) {
        if (!productUsesTierPricing(product)) return null;

        var target = resolveTierVariantForQuantity(product, currentVariantId, qty);
        if (!target || target.id === currentVariantId) return null;

        var addItem = { id: target.id, quantity: qty };
        var sellingPlanId = $lineItem.attr('data-selling-plan-id');
        if (sellingPlanId) {
          addItem.selling_plan = parseInt(sellingPlanId, 10);
        }

        var lineKey = String($lineItem.attr('data-key') || '').trim();

        return postCartJson('cart/add.js', { items: [addItem] }).then(function () {
          var removeBody;
          if (lineKey) {
            removeBody = { id: lineKey, quantity: 0 };
          } else if (changeTarget && changeTarget.byLine) {
            removeBody = { line: changeTarget.idOrLine, quantity: 0 };
          } else if (changeTarget && changeTarget.idOrLine != null) {
            removeBody = { id: changeTarget.idOrLine, quantity: 0 };
          } else {
            return fetchCart();
          }
          return postCartJson('cart/change.js', removeBody).then(function () {
            return fetchCart();
          });
        });
      })
      .catch(function (err) {
        console.warn('[CartTierVariant]', err);
        return null;
      });
  }

  global.CartTierVariant = {
    trySwapLineForQuantity: trySwapLineForQuantity,
    resolveTierVariantForQuantity: resolveTierVariantForQuantity,
    productUsesTierPricing: productUsesTierPricing,
  };
})(typeof window !== 'undefined' ? window : this);
